export default __webpack_public_path__ + "static/Hazard_Suit_Pants-6b26b7e286b4d5d15a4535e9ff26b129.png";